import React from 'react';

const TableauV = ({
    Entete, Lignes, Pied, PasDeZebrures, PetitesLignes, className,
}) => (
    <div className="table-responsive small card">
        <table width="100%"
            className={`acc-table-vote  table ${PasDeZebrures ? '' : 'table-striped'} ${
                PetitesLignes ? 'table-sm' : ''
            } ${className}`}
        >
            <thead>{Entete}</thead>
            <tbody>
                {Lignes}
                {Pied}
            </tbody>
        </table></div>
);

export default TableauV;



// WEBPACK FOOTER //
// ./src/components/TableauV.js